import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LanguageSwitcherComponent } from "./language-switcher.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreCommonModule } from "@core/common.module";

@NgModule({
  declarations: [LanguageSwitcherComponent],
  imports: [CommonModule, TranslateModule, NgbModule, CoreCommonModule],
  exports: [LanguageSwitcherComponent]
})
export class LanguageSwitcherModule {}
